import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {formatNumber} from '../../helpers/formatHelper';
import {login} from '../../helpers/login';
import {getDetailProduct, addCart, addPreOrder} from "../services/detailsService";
import {cartShowCount, orderShowCount} from "../../helpers/HeaderShow";


function MainController(props) {
    const id = document.getElementById('product-detail-app').getAttribute("data-id");
    const [product, setProduct] = useState({});
    const [quantityKW, setQuantityKW] = useState(0);
    const [price, setPrice] = useState(0);
    const [listProductPropertiesSelect, setListProductPropertiesSelect] = useState([]);
    const [quantityBuy, setQuantityBuy] = useState(1);
    const [productSimilarSelect, setProductSimilarSelect] = useState(0);
    const [err, setErr] = useState("");
    const [disable, setDisable] = useState(true);
    const [isLoad, setIsload] = useState(false);
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        getDetailProduct({id: id}, (rs) => {
            setIsload(true);
            setProduct(rs);
            setQuantityKW(rs.quantityKW);
            setPrice(rs.showPrice);
            setIsLogin(rs.isLogin);
            setDisable(false);
            if (rs.productProperties.length == 0 && rs.productSimilar.length == 1) {
                setProductSimilarSelect(rs.productSimilar[0].id);
            }
        });
    }, []);
    useEffect(() => {
        if (product?.productProperties?.length > 0) {
            product?.productProperties.forEach(function (item) {
                let listV = item?.productPropertieValue ?? [];
                if (listV.length === 1) {
                    let e = {
                        currentTarget: {
                            name: item.id,
                            value: listV[0].id
                        }
                    }
                    method.selectProperties(e);
                }
            })
        }
    }, [product])

    const canBy = useMemo(() => {
        return quantityKW >= quantityBuy
    }, [quantityKW, quantityBuy])
    const method = {
        isValid: (checkQuantity = true) => {
            let isCheck = true;
            if (productSimilarSelect > 0) {
                isCheck = isCheck && true;
                setErr("");
            } else {
                isCheck = isCheck && false;
                setErr("Vui lòng chọn phân loại hàng");
            }
            return isCheck;
        },
        showModalSuccess: (content) => {
            $("#modal-detail-p-success").addClass("show");
            $("#modal-detail-p-content").html(content);
            setTimeout(() => {
                $("#modal-detail-p-success").removeClass("show");
            }, 2000);
        },
        saveCart: async (e) => {
            new Promise(function (resolve, reject) {
                resolve("true");
            }).then((value) => {
                if (value === "true" && method.isValid()) {
                    let param = {
                        ProductId: id,
                        ProductSimilarId: productSimilarSelect,
                        Quantity: quantityBuy,
                        type: 1
                    };
                    let reloadTimeout;
                    if (window?.isLoggedin === "True") {
                        addCart(param, (rs) => {
                            if (rs.statusCode === 200) {
                                cartShowCount(rs.data);
                                method.showModalSuccess("Thêm sản phẩm vào giỏ hàng thành công");
                                reloadTimeout = setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            } else {
                                setErr(rs.err);
                            }
                        });
                        clearTimeout(reloadTimeout)
                    } else {
                        const paramLocalStorage = {
                            productSimilarId: productSimilarSelect,
                            quantity: quantityBuy,
                            type: 1
                        }
                        let cart = JSON.parse(localStorage.getItem("cart")) ?? [];
                        let index = cart.findIndex(x => x.productSimilarId === productSimilarSelect);
                        if (index > -1) {
                            cart[index].quantity += quantityBuy;
                        } else {
                            cart.push(paramLocalStorage);
                            cartShowCount(1);
                        }
                        localStorage.setItem("cart", JSON.stringify(cart));
                        method.showModalSuccess("Thêm sản phẩm vào giỏ hàng thành công");
                    }

                }
            })
        },

        saveOrder: (e) => {
            new Promise(function (resolve, reject) {
                resolve("true");
            }).then((value) => {
                if (value == "true" && method.isValid()) {
                    if (window?.isLoggedin === "True") {
                        let param = {
                            ProductId: id,
                            ProductSimilarId: productSimilarSelect,
                            Quantity: quantityBuy,
                            type: 2
                        };
                        addCart(param, (rs) => {
                            if (rs.statusCode == 200) {
                                window.location.href = "/cart";
                            } else {
                                setErr(rs.err);
                            }
                        });
                    } else {
                        const paramLocalStorage = {
                            productSimilarId: productSimilarSelect,
                            quantity: quantityBuy,
                            type: 2
                        }
                        let cart = JSON.parse(localStorage.getItem("cart")) ?? [];
                        let index = cart.findIndex(x => x.productSimilarId === productSimilarSelect);
                        if (index > -1) {
                            cart[index].quantity = quantityBuy;
                        } else {
                            cart.push(paramLocalStorage);
                            cartShowCount(1);
                        }
                        localStorage.setItem("cart", JSON.stringify(cart));
                        window.location.href = "/cart";
                    }

                }
            })
        },
        savePreOrder: (e) => {
            new Promise(function (resolve, reject) {
                resolve("true");
            }).then((value) => {
                if (value == "true" && method.isValid(false)) {
                    let param = {
                        ProductId: id,
                        ProductSimilarId: productSimilarSelect,
                        Quantity: quantityBuy,
                        type: 2
                    };
                    addPreOrder(param, (rs) => {
                        if (rs.statusCode === 200) {
                            window.location.href = "/PreOrders/ReOrder/Checkout/?state=" + rs.data;
                        } else {
                            setErr(rs.err);
                        }
                    });
                }
            })
        },
        selectProperties: async (e) => {
            let listProductSimilar = product?.productSimilar ?? [];
            let listProductProperties = product?.productProperties ?? [];

            let obj = {
                id: e.currentTarget.name,
                value: e.currentTarget.value
            }
            let currentSelect = [...listProductPropertiesSelect];
            let checkIndex = currentSelect.findIndex(x => x.id == obj.id);
            if (checkIndex > -1) {
                currentSelect.splice(checkIndex, 1);
            }
            currentSelect.push(obj);
            if (currentSelect.length === listProductProperties.length) {
                let index = listProductSimilar.findIndex(x => {
                    if (x.productPropertieValue != null && x.productPropertieValue.length > 0) {
                        let a = x.productPropertieValue.split(",");
                        let isCheck = true;
                        currentSelect.forEach(s => {
                            let c = a.findIndex(x => x == s.value);
                            isCheck = isCheck && (c > -1);
                        })
                        return isCheck;
                    }
                })
                if (index > -1) {
                    let productSimilar = listProductSimilar[index];
                    setPrice(formatNumber(productSimilar?.price));
                    setQuantityKW(productSimilar?.quantityWh);
                    setProductSimilarSelect(productSimilar?.id);
                    setErr("");
                } else {
                    setProductSimilarSelect(0);
                }
            }
            setListProductPropertiesSelect(currentSelect);
        },
        changeQuantityBuy: (e) => {
            if (method.isValid(false)) {
                const targetValue = e.currentTarget.value;
                // if (targetValue.length > 5) return;
                let quantity = Math.floor(targetValue);
                if (targetValue > 1000) return;
                setQuantityBuy(quantity);
                // if (quantityKW >= quantity) {
                //     setErr("");
                // } else {
                //     setErr("Số lượng vượt quá hàng tồn kho. Vui lòng đặt hàng trước");
                // }
            }
        },
        clickQuantityBuy: (type) => {
            if (method.isValid(false)) {
                if (type === 1) {
                    let q = quantityBuy - 1;
                    if (q < 0) return;
                    if (q < 1) {
                        setQuantityBuy(1);
                    } else {
                        setQuantityBuy(q);
                    }
                    // if (quantityKW >= q) {
                    //     setErr("");
                    // } 
                    // else {
                    //     setErr("Số lượng vượt quá hàng tồn kho. Vui lòng đặt hàng trước");
                    // }
                } else if (type === 2) {
                    let q = quantityBuy + 1;
                    if (q > 1000) return;
                    setQuantityBuy(q);
                    // if (quantityKW >= q) {
                    //     setErr("");
                    // } else {
                    //     setErr("Số lượng vượt quá hàng tồn kho. Vui lòng đặt hàng trước");
                    // }
                }
            }
        },
        isChecked: useCallback((name, value) => {
            let index = listProductPropertiesSelect.findIndex(x => x.id == name && x.value == value);
            return index > -1;
        }, [listProductPropertiesSelect]),
        shareFace: () => {
            FB.ui({
                method: 'feed',
                name: "",
                link: window.ogUrl,
                picture: window.ogImage,
                caption: "",
                description: "",
                message: ""
            });
        }
    };

    return {method, state: {canBy, product, quantityBuy, quantityKW, price, err, disable, isLoad, isLogin}}
}

export default MainController;